/* eslint-disable react-refresh/only-export-components -- toast object co-located with its Toaster mount */
/**
 * Toast — the one place `sonner` is imported from (CLAUDE.md's UI-library rule names it
 * explicitly, alongside `@radix-ui/*`/`@xyflow/react`/`@tiptap/*`). Added per `/audit:audit-storybook`
 * SB-003: 96 call sites imported `sonner` directly with no wrapping Atomic.
 *
 * `toast` re-exports sonner's own object untouched — every existing `toast.success(...)` /
 * `toast.error(...)` / `toast.info(...)` call site keeps its exact signature, so migrating off the
 * direct `sonner` import is a mechanical import-path change, not a behavior change. `Toaster` pins
 * the app's one configured mount (`position="top-right" richColors closeButton`, previously inlined
 * in `main.tsx`) so that configuration lives in one place instead of being free to drift per mount.
 */
import { Toaster as SonnerToaster, toast } from 'sonner'

export { toast }

export function Toaster() {
  return <SonnerToaster position="top-right" richColors closeButton />
}
